<template>
  <div v-if="(['1','2','3','5']).indexOf(mantraid) > -1" class="uyh-text-design-container">
    <div  class="uyh-background primary" :style="[getBackground(primary)]" :class="[tempId(mantraid)]" :data-template="tempId(mantraid).split('temp-')[1]">
      <div class="uyh-background image" :style="{backgroundImage: `url('${featureImage}')`}"></div>
      <div class="uyh-background textarea" :style="[getBackground(textarea)]" :class="[{border: hasBorder(textareaborder)}]">
        <p v-if="hashtag != ''" class="uyh-hashtag" :style="{color: textcolor}">{{ $t('mantras.hashtags.' + hashtag) }}</p>
        <h1 :class="textweight" :style="{color: textcolor}" v-html="$t('mantras.messages.image.' + message)"></h1>
        <svg v-if="icon == 'true'" svg-inline="" :style="{fill: textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
      </div>
    </div>
  </div>
  <div v-else-if="(['4']).indexOf(mantraid) > -1" class="uyh-text-design-container">
    <div  class="uyh-background primary" :style="[getBackground(primary)]" :class="[tempId(mantraid)]" :data-template="tempId(mantraid).split('temp-')[1]">
      <div class="uyh-background image" :style="{backgroundImage: `url('${featureImage}')`}"></div>
      <div v-if="secondary" class="uyh-background secondary" :style="[getBackground(secondary)]"></div>
      <div class="uyh-background textarea" :style="[getBackground(textarea)]" :class="[{border: hasBorder(textareaborder)}]">
        <p v-if="hashtag != ''" class="uyh-hashtag" :style="{color: textcolor}">{{ $t('mantras.hashtags.' + hashtag) }}</p>
        <h1 :class="textweight" :style="{color: textcolor}" v-html="$t('mantras.messages.image.' + message)"></h1>
        <svg v-if="icon == 'true'" svg-inline="" :style="{fill: textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
      </div>
    </div>
  </div>
  <div v-else-if="(['6']).indexOf(mantraid) > -1" class="uyh-text-design-container">
    <div  class="uyh-background primary" :style="[getBackground(primary)]" :class="[tempId(mantraid)]" :data-template="tempId(mantraid).split('temp-')[1]">
      <svg v-if="icon == 'true'" svg-inline="" :style="{fill: textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
      <div class="uyh-background image" :style="{backgroundImage: `url('${featureImage}')`}"></div>
      <div class="uyh-background textarea" :style="[getBackground(textarea)]" :class="[{border: hasBorder(textareaborder)}]">
        <h1 :class="textweight" :style="{color: textcolor}" v-html="$t('mantras.messages.image.' + message)"></h1>
        <p v-if="hashtag != ''" class="uyh-hashtag" :style="{color: textcolor}">{{ $t('mantras.hashtags.' + hashtag) }}</p>
      </div>
    </div>
  </div>
  <div v-else-if="(['7']).indexOf(mantraid) > -1" class="uyh-text-design-container">
    <div  class="uyh-background primary" :style="[getBackground(primary)]" :class="[tempId(mantraid)]" :data-template="tempId(mantraid).split('temp-')[1]">
      <div class="uyh-background image" :style="{backgroundImage: `url('${featureImage}')`}"></div>
      <div v-if="secondary" class="uyh-background secondary" :style="[getBackground(secondary)]"></div>
      <div class="uyh-background textarea" :style="[getBackground(textarea)]" :class="[{border: hasBorder(textareaborder)}]">
        <p v-if="hashtag != ''" class="uyh-hashtag" :style="{color: textcolor}">{{ $t('mantras.hashtags.' + hashtag) }}</p>
        <h1 :class="textweight" :style="{color: textcolor}" v-html="$t('mantras.messages.image.' + message)"></h1>
        <svg v-if="icon == 'true'" svg-inline="" :style="{fill: textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
      </div>
    </div>
  </div>
  <div v-else-if="(['9']).indexOf(mantraid) > -1" class="uyh-text-design-container">
    <div  class="uyh-background primary" :style="[getBackground(primary)]" :class="[tempId(mantraid)]" :data-template="tempId(mantraid).split('temp-')[1]">
      <div v-if="secondary" class="uyh-background secondary" :style="[getBackground(secondary)]"></div>
      <div class="uyh-background textarea">
        <p v-if="hashtag != ''" class="uyh-hashtag" :style="{color: textcolor}">{{ $t('mantras.hashtags.' + hashtag) }}</p>
        <h1 :class="textweight" :style="{color: textcolor}" v-html="$t('mantras.messages.image.' + message)"></h1>
        <div class="uyh-background image" :style="{backgroundImage: `url('${featureImage}')`}"></div>
        <svg v-if="icon == 'true'" svg-inline="" :style="{fill: textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
      </div>
    </div>
  </div>
  <div v-else-if="(['8', '10']).indexOf(mantraid) > -1" class="uyh-text-design-container">
    <div  class="uyh-background primary" :style="[getBackground(primary)]" :class="[tempId(mantraid)]" :data-template="tempId(mantraid).split('temp-')[1]">
      <div class="uyh-background textarea">
        <p v-if="hashtag != ''" class="uyh-hashtag" :style="{color: textcolor}">{{ $t('mantras.hashtags.' + hashtag) }}</p>
        <h1 :class="textweight" :style="{color: textcolor}" v-html="$t('mantras.messages.image.' + message)"></h1>
        <div class="uyh-background image" :style="{backgroundImage: `url('${featureImage}')`}"></div>
        <svg v-if="icon == 'true'" svg-inline="" :style="{fill: textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
      </div>
    </div>
  </div>
  <div v-else-if="(['11']).indexOf(mantraid) > -1" class="uyh-text-design-container">
    <div  class="uyh-background primary" :style="[getBackground(primary)]" :class="[tempId(mantraid)]" :data-template="tempId(mantraid).split('temp-')[1]">
      <div class="uyh-background textarea">
        <div class="uyh-background image" :style="{backgroundImage: `url('${featureImage}')`}"></div>
        <h1 :class="textweight" :style="{color: textcolor}" v-html="$t('mantras.messages.image.' + message)"></h1>
        <p v-if="hashtag != ''" class="uyh-hashtag" :style="{color: textcolor}">{{ $t('mantras.hashtags.' + hashtag) }}</p>
        <svg v-if="icon == 'true'" svg-inline="" :style="{fill: textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
      </div>
    </div>
  </div>
  <div v-else-if="(['12']).indexOf(mantraid) > -1" class="uyh-text-design-container">
    <div class="uyh-background primary" :style="[getBackground(primary)]" :class="[tempId(mantraid)]" :data-template="tempId(mantraid).split('temp-')[1]">
      <svg v-if="icon == 'true'" svg-inline="" :style="{fill: textarea}" class="icon" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
      <div class="uyh-background secondary" :style="[getBackground(secondary)]"></div>
      <div class="uyh-background image" :style="{backgroundImage: `url('${featureImage}')`}"></div>
      <div class="uyh-background textarea" :class="[{border: hasBorder(textareaborder)}]">
        <p v-if="hashtag"  class="uyh-hashtag" :style="{color: textcolor}">{{ $t('mantras.hashtags.' + hashtag) }}</p>
        <svg svg-inline="" :style="{fill: textarea}" class="large-spade" role="presentation" focusable="false" width="328" height="310" viewBox="0 0 328 310" xmlns="http://www.w3.org/2000/svg"><path d="M101.784 302.86v-4.486c0-10.128 3.198-19.395 14.672-41.168l28.414-53.72-6.962-3.376c-11.293 16.494-29.729 46.946-68.46 46.923-38.007-.023-64.493-29.885-64.493-69.354.023-37.588 26.758-66.498 61.544-95.227l95.174-79.074h3.765l95.128 79.142c34.786 28.752 61.84 57.345 61.817 94.91-.023 39.446-26.872 69.693-64.878 69.693-38.754-.022-57.213-30.473-68.484-46.99l-6.916 3.353 28.369 53.765c11.451 21.774 14.649 31.04 14.649 41.168v4.509l-123.339-.068" fill-rule="evenodd"/></svg>
        <h1 :class="textweight" :style="{color: textcolor}" v-html="$t('mantras.messages.text.' + message)"></h1>
      </div>
    </div>
  </div>

  
</template>

<script>
  const rootHost = process.env.BASE_URL;

  export default {
    props: ["mantraid", "primary", "secondary", "textarea", "textcolor", "textweight", "textareaborder", "icon", "hashtag", "message"],
    methods: {
      hasBorder: function(borderValue) {
        var border = false;
        if (borderValue == 'border') {
          border = true;
        }
        return border;
      },
      tempId: function(mantraId) {
        return 'temp-' + mantraId.toString();
      },
      getBackground: function(backgroundData) {
        if (backgroundData.includes('patterns')) {
          if (backgroundData.includes('_Swatch')) {
            backgroundData = backgroundData.replace('_Swatch', '_640X640');
          }
          return { backgroundImage: 'url(' + rootHost + backgroundData + ')' }
        } else {
          return { background: backgroundData }
        }
      }
    },
    computed: {
      featureImage() {
        return rootHost + 'img/placeholder.jpg';
      }
    }
  }
</script>

<style lang="scss" scoped>
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    $mobile-breakpoint: 767px;
    $tablet-portrait-down-breakpoint: 1023px;
    $tablet-portrait-breakpoint: 1024px;
    $tablet-down-breakpoint: 1199px;
    $hd-desktop-breakpoint: 1280px;

    .slick-slide {
      padding: 0 25px;
      position: relative;
      transition: scale 0.3s ease-in-out;
      .uyh-background {
        &.primary {
          max-width: 100%;
          transform: scale(0.85);
          width: 640px;
          @media screen and (min-width: 1200px) and (max-width: $hd-desktop-breakpoint) {
            max-width: calc(50vw - 6.7rem);
            width: calc(100vh - 210px);
          }

          &.temp-1,
          &.temp-2,
          &.temp-3,
          &.temp-4,
          &.temp-5,
          &.temp-6,
          &.temp-7 {
            .image {
              background-position: 50% 50%;
              background-size: cover;
              box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
              left: 50%;
              height: calc(51 / 64 * 100%);
              overflow: hidden;
              position: absolute;
              top: 30px;
              transform: translateX(-50%);
              width: calc(17 / 32 * 100%);
              @media screen and (max-width: $tablet-portrait-down-breakpoint) {
                top: 25px;
              }
            }

            .textarea,
            .secondary {
              bottom: 30px;
              height: 200px;
              top: initial;
              transform: translateX(-50%);
              width: 200px;
              @media screen and (min-width: 1200px) and (max-width: $hd-desktop-breakpoint) {
                bottom: 10px;
                height: 130px;
                width: 130px;
              }
              @media screen and (max-width: $tablet-down-breakpoint) {
                bottom: 15px;
                height: 150px;
                width: 150px;
              }
              @media screen and (max-width: $tablet-portrait-down-breakpoint) {
                bottom: 10px;
                height: 130px;
                width: 130px;
              }
            }

            .textarea {
              padding: 16px 0 6px;
              @media screen and (max-width: $tablet-portrait-down-breakpoint) {
                padding: 10px 0 0;
              }

              h1 {
                font-size: 27px;
                margin: 0;
                @media screen and (max-width: $hd-desktop-breakpoint) {
                  font-size: calc(27px * 450 / 640);
                }
                @media screen and (max-width: $tablet-portrait-down-breakpoint) {
                  font-size: 18px;
                  line-height: 1.25;
                }
              }

              .uyh-hashtag {
                @media screen and (max-width: $tablet-portrait-down-breakpoint) {
                  font-size: 11px;
                }
              }

              svg {
                height: 22px;
                width: 22px;
                @media screen and (max-width: $tablet-portrait-down-breakpoint) {
                  height: 13.5px;
                  width: 13.5px;
                }
              }
            }
          }

          &.temp-1,
          &.temp-2 {
            .textarea {
              h1 {
                line-height: 1.05;
              }
            }
          }

          &.temp-1 {
            @media screen and (max-width: $mobile-breakpoint) {
              .textarea {
                h1 {
                  font-size: 16px;
                  line-height: 1;
                }
              }
            }
          }


          &.temp-4 {
            .textarea {
              bottom: 45px;
              height: 170px;
              width: 170px;
              @media screen and (min-width: 1200px) and (max-width: $hd-desktop-breakpoint) {
                bottom: 20px;
                height: 110px;
                width: 110px;
              }
              @media screen and (max-width: $tablet-down-breakpoint) {
                bottom: 17.5px;
                height: 130px;
                width: 130px;
              }
            }
            .secondary {
              @media screen and (min-width: 1200px) and (max-width: $hd-desktop-breakpoint) {
                height: 130px;
                width: 130px;
              }
              @media screen and (max-width: $tablet-down-breakpoint) {
                bottom: 10px;
                height: 145px;
                width: 145px;
              }
            }
          }

          &.temp-3,
          &.temp-5,
          &.temp-6 {
            .textarea {
              h1 {
                line-height: 1.25;
              }
            }
          }

          &.temp-5 {
            @media screen and (max-width: $mobile-breakpoint) {
              .textarea {
                h1 {
                  line-height: 1.05;
                }
              }
            }
          }

          &.temp-6 {
            svg {
              height: 30px;
              left: 50%;
              position: absolute;
              top: 7.5px;
              transform: translateX(-50%);
              width: 30px;
            }
            .image {
              top: 45px;
            }
            .textarea {
              padding: 12px 0;
            }
          }

          &.temp-7 {
            .textarea {
              padding: 8px 0 0;
              height: 175px;
              width: 175px;
              h1 {
                font-size: 35px;
              }
            }
            .secondary {
              bottom: 56px;
              height: 118px;
              width: 235px;
            }
            // @media screen and (min-width: 1200px) and (max-width: $hd-desktop-breakpoint) {
            @media screen and (max-width: $hd-desktop-breakpoint) {
              .textarea {
                bottom: 10px;
                height: calc(175px * 500 / 640);
                width: calc(175px * 500 / 640);
                h1 {
                  font-size: calc(35px * 500 / 640)
                }
              }
              .secondary {
                bottom: 32px;
                height: calc(118px * 500 / 640);
                width: calc(235px * 500 / 640);
              }
            }
            @media screen and (max-width: $mobile-breakpoint) {
              .textarea {
                bottom: 10px;
                height: calc(175px * 400 / 640);
                width: calc(175px * 400 / 640);
                h1 {
                  font-size: calc(35px * 400 / 640)
                }
              }
              .secondary {
                bottom: 26px;
                height: calc(118px * 400 / 640);
                width: calc(235px * 400 / 640);
              }
            }
          }
          &.temp-8,
          &.temp-9,
          &.temp-10,
          &.temp-11 {
            .textarea {
              align-items: initial;
              box-shadow: none;
              height: calc(100% - 44px);
              left: 0;
              position: absolute;
              top: 0;
              transform: none;
              width: 100%;
              h1 {
                margin: 0;
              }
              .image {
                background-position: 50% 50%;
                background-size: cover;
                box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
                margin: 0 auto;
                overflow: hidden;
                position: relative;
                width: 42.96875%;
                &:before {
                  content: '';
                  display: block;
                  padding-top: 150%;
                }

                @media screen and (max-width: $tablet-portrait-down-breakpoint) {
                  top: 25px;
                }
              }
              svg {
                bottom: -32px;
                height: 20px;
                left: 50%;
                position: absolute;
                transform: translateX(-50%);
                width: 20px;
              }
              @media screen and (max-width: $tablet-down-breakpoint) {
                padding: 0 15px;
                .image {
                  top: 0;
                }
              }
              @media screen and (max-width: $tablet-portrait-down-breakpoint) {
                svg {
                  margin-top: 6px;
                }
              }
              @media screen and (max-width: $mobile-breakpoint) {
                svg {
                  margin-top: 0px;
                }
              }
            }
          }

          &.temp-8 {
            .textarea {
              .uyh-hashtag {
                margin-top: 8px;
              }
              h1 {
                font-size: 40px;
                @media screen and (max-width: $hd-desktop-breakpoint) {
                  font-size: calc(40px * 375 / 640);
                }
                @media screen and (max-width: $tablet-down-breakpoint) {
                  font-size: calc(40px * 500 / 640);
                }
                @media screen and (max-width: $mobile-breakpoint) {
                  font-size: 20px;
                }
              }
            }
          }

          &.temp-9 {
            .secondary {
              box-shadow: none;
              height: 100%;
              position: absolute;
              right: 0;
              top: 0;
              transform: none;
              width: 50%;
            }
            .textarea {
              .uyh-hashtag {
                margin-top: 8px;
              }
              h1 {
                font-size: 60px;
                margin-bottom: -8px;
              }
              @media screen and (max-width: $hd-desktop-breakpoint) {
                h1 {
                  font-size: calc(60px * 375 / 640);
                  margin-bottom: -4px;
                }
              }
              
              @media screen and (max-width: $tablet-portrait-down-breakpoint) {
                h1 {
                  font-size: 30px;
                  margin-bottom: -8px;
                }
              }
            }
          }

          &.temp-10 {
            .textarea {
              .uyh-hashtag {
                margin-top: 8px;
              }
              h1 {
                font-size: 60px;
                line-height: 1.25;
                margin-bottom: -0.8em;
                z-index: 1;
                @media screen and (max-width: $hd-desktop-breakpoint) {
                  font-size: calc(60px * 375 / 640);
                  margin-bottom: -0.8em;
                }
                @media screen and (max-width: $tablet-down-breakpoint) {
                  font-size: calc(60px * 500 / 640);
                  line-height: 1.15;
                  margin-bottom: -0.9em;
                }
                @media screen and (max-width: $tablet-portrait-down-breakpoint) {
                  line-height: 1.15;
                  margin-bottom: -0.65em;
                }
                @media screen and (max-width: $mobile-breakpoint) {
                  font-size: 35px;
                  line-height: 1.25;
                  margin-bottom: -0.9em;
                }
              }
            }
          }

          &.temp-11 {
            .textarea {
              padding: 20px 0 0;
              .uyh-hashtag,
              svg {
                line-height: 0;
                margin-top: 0;
              }
              h1 {
                font-size: 60px;
                line-height: 1.15;
                margin-top: -108px;
                z-index: 1;
                @media screen and (max-width: $hd-desktop-breakpoint) {
                  font-size: calc(60px * 375 / 640);
                  margin-top: -65px;
                }
                @media screen and (max-width: $tablet-down-breakpoint) {
                  font-size: calc(60px * 500 / 640);
                  margin-top: -84px;
                }
                @media screen and (max-width: $mobile-breakpoint) {
                  font-size: 40px;
                  margin-top: -72px;
                }
              }
            }
          }

          &.temp-12 {
            .image {
              background-position: 50% 50%;
              background-size: cover;
              box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
              left: 50%;
              margin: 0 auto;
              overflow: hidden;
              position: absolute;
              top: 60px;
              transform: translateX(-50%);
              width: 42.96875%;
              &:before {
                content: '';
                display: block;
                padding-top: 150%;
              }
            }
            .secondary {
              box-shadow: none;
              height: 100%;
              position: absolute;
              right: 0;
              top: 0;
              transform: none;
              width: 50%;
            }
            svg {
              bottom: initial;
              left: 50%;
              position: absolute;
              top: 20px;
              transform: translateX(-50%);
              z-index: 1;
            }
            .textarea {
              box-shadow: none;
              bottom: 20px;
              height: 200px;
              left: 50%;
              padding: 0;
              position: absolute;
              top: initial;
              transform: translateX(-50%);
              width: 200px;
              @media screen and (max-width: $hd-desktop-breakpoint) {
                height: 130px;
                width: 130px;
              }
              @media screen and (max-width: $tablet-down-breakpoint) {
                height: calc(200px * 600 / 640);
                width: calc(200px * 600 / 640);
              }
              @media screen and (max-width: $tablet-portrait-breakpoint) {
                height: calc(200px * 500 / 640);
                width: calc(200px * 500 / 640);
              }
              @media screen and (max-width: $mobile-breakpoint) {
                height: calc(200px * 400 / 640);
                width: calc(200px * 400 / 640);
              }
              .large-spade {
                height: 100%;
                top: initial;
                margin-top: 0;
                width: 100%;
                z-index: 0;
              }
              .uyh-hashtag,
              h1 {
                margin: 0;
              }
              .uyh-hashtag {
                left: 50%;
                font-size: 12px;
                position: absolute;
                top: 45px;
                transform: translateX(-50%);
                z-index: 1;
                @media screen and (max-width: $hd-desktop-breakpoint) {
                  top: 34px;
                }
                @media screen and (max-width: $tablet-down-breakpoint) {
                  top: 42px;
                }
                @media screen and (max-width: $mobile-breakpoint) {
                  top: 30px;
                }
              }
              h1 {
                font-size: 27px;
                left: 50%;
                position: absolute;
                top: 48%;
                transform: translateX(-50%) translateY(-50%);
                z-index: 1;
                @media screen and (max-width: $hd-desktop-breakpoint) {
                  top: 50%;
                  font-size: calc(27px * 375 / 640);
                }
                @media screen and (max-width: $tablet-down-breakpoint) {
                  font-size: calc(27px * 500 / 640);
                }
                @media screen and (max-width: $mobile-breakpoint) {
                  font-size: 15px;
                }
              }
            }
          }
        }
        @media screen and (min-width: 1200px) and (max-width: $hd-desktop-breakpoint) {
          &.textarea {
            &.border {
              outline: 7px white solid;
              outline-offset: -7px;
            }
          }
        }
        @media screen and (max-width: $hd-desktop-breakpoint) {
          &.textarea {
            &.border {
              outline: 7px white solid;
              outline-offset: -7px;
            }
          }
        }
      }

      &.slick-current {
        .primary {
          transform: scale(1);
        }
      }
    }

    // Landscape tablet top
    @media screen and (max-width: 1199px) {
      .uyh-background {
        &.primary {
          max-width: 100%;
          min-height: 400px;
          min-width: 400px;
        }
        &.textarea {
          p, h1, svg {
            margin: 0 auto;
          }
        }
      }
    }

    // Portrait tablet top
    @media screen and (max-width: 1023px) {
      .slick-slide {
        padding: 0 5px;
      }
      .uyh-background {
        &.primary {
          max-width: calc(100vh - 320px);
          width: 100%;
        }
      }
    }

    // Mobile top
    @media screen and (max-width: 767px) {
      .slick-slide {
        padding: 0;
        a {
          &:hover {
            transform: scale(1) translateX(-50%);
          }
        }
        .primary {
          margin: 0 auto;
          max-width: 400px;
          min-width: 375px;
          width: calc(100vw - 50px);
        }
        &.slick-current {
          .primary {
            transform: scale(1);
          }
        }
      }
    }

    // Mobile exception
    @media screen and (max-width: 400px) {
      .slick-slide {
        &.slick-current {
          .primary {
            &:before {
              padding-top: 400px;
            }
          }
        }
      }
    }
  }
</style>
